import { useCallback, useEffect } from 'react';
import { INTERSECTION_OBSERVER_OPTIONS } from '../constants';

interface UseIntersectionObserverProps {
  targetRef: React.RefObject<HTMLElement>;
  onIntersect: () => void;
  enabled: boolean;
}

export const useIntersectionObserver = ({ targetRef, onIntersect, enabled }: UseIntersectionObserverProps) => {
  const handleObserver = useCallback(
    (entries: IntersectionObserverEntry[]) => {
      const [target] = entries;
      if (target.isIntersecting && enabled) {
        onIntersect();
      }
    },
    [onIntersect, enabled],
  );

  useEffect(() => {
    const observer = new IntersectionObserver(handleObserver, INTERSECTION_OBSERVER_OPTIONS);
    if (targetRef.current) {
      observer.observe(targetRef.current);
    }

    return () => {
      if (targetRef.current) {
        observer.unobserve(targetRef.current);
      }
    };
  }, [handleObserver, targetRef]);
};
